import {BehaviorSubject, Observable, throwError} from "rxjs";
import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {UrlService} from "../../common/url.service";
import {ISavedProduct, ISaveProductRequest} from "./cart-saved-product-models";
import {catchError, map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class CartSavedProductService {

    private savedProductSubject: BehaviorSubject<ISavedProduct[]> = new BehaviorSubject([]);
    savedProducts$: Observable<ISavedProduct[]> = this.savedProductSubject.asObservable();

    constructor(private http: HttpClient, private urlService: UrlService) {
    }

    getSavedForLaterProducts(): Observable<void> {
        return this.http.get<ISavedProduct[]>(this.urlService.buildCartUrl('/savedForLater')).pipe(
            map((response: ISavedProduct[]) => this.savedProductSubject.next(response)),
            catchError(error => throwError(error))
        );
    }

    // returns the updated saved for later product list
    saveProductForLater(usanaId: string, mhpId: number, quantity: number):  Observable<void> {
        const request = {
            usanaId: usanaId,
            mhpId: mhpId,
            quantity: quantity
        } as ISaveProductRequest;

        const url = this.urlService.buildCartUrl(`/savedForLater`);

        return this.http.put<ISavedProduct[]>(url, request).pipe(
            map((response: ISavedProduct[]) => this.savedProductSubject.next(response)),
            catchError(error => throwError(error))
        );
    }

    // returns the updated saved for later product list
    deleteSavedForLaterProduct(usanaId: string, mhpId: number): Observable<void> {
        let url = this.urlService.buildCartUrl(`/savedForLater?usanaId=${usanaId}`);
        if (mhpId) {
            url += `&mhpId=${mhpId}`;
        }

        return this.http.delete<ISavedProduct[]>(url).pipe(
            map((response: ISavedProduct[]) => this.savedProductSubject.next(response)),
            catchError(error => throwError((error)))
        );
    }
}
